var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.goldBoxEcuAttributes && _vm.goldBoxEcuAttributes.length)?_c('ProductGoldBoxEcuTable',{attrs:{"goldBoxEcus":_vm.goldBoxEcuAttributes,"tableClass":"table-mobile"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }